/* eslint-disable */
import { Icon } from '@pwc/pwc-deals-ui';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { IPowerPivotNotSupportedModalProps } from '../interfaces/IPowerPivotNotSupportedModalProps';
import { resetPowerPivotFlags } from '../redux/powerPivotSlice';
import styles from './PowerPivotNotSupportedModal.module.scss';

const PowerPivotNotSupportedModal = ({
  title,
  message,
}: IPowerPivotNotSupportedModalProps) => {
  const dispatch = useDispatch();

  const showPowerPivotNotSupportedModal = useSelector(
    (state: any) => state.powerPivot.showPowerPivotNotSupportedModal
  );

  return (
    <>
      {showPowerPivotNotSupportedModal ? (
        <Modal
          show={showPowerPivotNotSupportedModal}
          // Reset Power Pivot flags to default value to have expected behavior next time this component is displayed
          onHide={() => dispatch(resetPowerPivotFlags())}
          className={styles['power-pivot-not-supported-modal']}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <Icon name="alert" className="icon-yellow fill" width="24" />
              {title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>{message}</Modal.Body>
        </Modal>
      ) : null}
    </>
  );
};

export default PowerPivotNotSupportedModal;
